import { Option } from "@/models/interfaces";

const FRA_ZIP_TABLE: { [code: string]: { aL6: string; aL4: string } } = {
  '01': { aL6: 'Ain', aL4: 'Auvergne-Rhône-Alpes' },
  '02': { aL6: 'Aisne', aL4: 'Hauts-de-France' },
  '03': { aL6: 'Allier', aL4: 'Auvergne-Rhône-Alpes' },
  '04': { aL6: 'Alpes-de-Haute-Provence', aL4: "Provence-Alpes-Côte d'Azur" },
  '05': { aL6: 'Hautes-Alpes', aL4: "Provence-Alpes-Côte d'Azur" },
  '06': { aL6: 'Alpes-Maritimes', aL4: "Provence-Alpes-Côte d'Azur" },
  '07': { aL6: 'Ardèche', aL4: 'Auvergne-Rhône-Alpes' },
  '08': { aL6: 'Ardennes', aL4: 'Grand Est' },
  '09': { aL6: 'Ariège', aL4: 'Occitanie' },
  '10': { aL6: 'Aube', aL4: 'Grand Est' },
  '11': { aL6: 'Aude', aL4: 'Occitanie' },
  '12': { aL6: 'Aveyron', aL4: 'Occitanie' },
  '13': { aL6: 'Bouches-du-Rhône', aL4: "Provence-Alpes-Côte d'Azur" },
  '14': { aL6: 'Calvados', aL4: 'Normandie' },
  '15': { aL6: 'Cantal', aL4: 'Auvergne-Rhône-Alpes' },
  '16': { aL6: 'Charente', aL4: 'Nouvelle-Aquitaine' },
  '17': { aL6: 'Charente-Maritime', aL4: 'Nouvelle-Aquitaine' },
  '18': { aL6: 'Cher', aL4: 'Centre-Val de Loire' },
  '19': { aL6: 'Corrèze', aL4: 'Nouvelle-Aquitaine' },
  '2A': { aL6: 'Corse-du-Sud', aL4: 'Corse' },
  '2B': { aL6: 'Haute-Corse', aL4: 'Corse' },
  '21': { aL6: "Côte-d'Or", aL4: 'Bourgogne-Franche-Comté' },
  '22': { aL6: "Côtes-d'Armor", aL4: 'Bretagne' },
  '23': { aL6: 'Creuse', aL4: 'Nouvelle-Aquitaine' },
  '24': { aL6: 'Dordogne', aL4: 'Nouvelle-Aquitaine' },
  '25': { aL6: 'Doubs', aL4: 'Bourgogne-Franche-Comté' },
  '26': { aL6: 'Drôme', aL4: 'Auvergne-Rhône-Alpes' },
  '27': { aL6: 'Eure', aL4: 'Normandie' },
  '28': { aL6: 'Eure-et-Loir', aL4: 'Centre-Val de Loire' },
  '29': { aL6: 'Finistère', aL4: 'Bretagne' },
  '30': { aL6: 'Gard', aL4: 'Occitanie' },
  '31': { aL6: 'Haute-Garonne', aL4: 'Occitanie' },
  '32': { aL6: 'Gers', aL4: 'Occitanie' },
  '33': { aL6: 'Gironde', aL4: 'Nouvelle-Aquitaine' },
  '34': { aL6: 'Hérault', aL4: 'Occitanie' },
  '35': { aL6: 'Ille-et-Vilaine', aL4: 'Bretagne' },
  '36': { aL6: 'Indre', aL4: 'Centre-Val de Loire' },
  '37': { aL6: 'Indre-et-Loire', aL4: 'Centre-Val de Loire' },
  '38': { aL6: 'Isère', aL4: 'Auvergne-Rhône-Alpes' },
  '39': { aL6: 'Jura', aL4: 'Bourgogne-Franche-Comté' },
  '40': { aL6: 'Landes', aL4: 'Nouvelle-Aquitaine' },
  '41': { aL6: 'Loir-et-Cher', aL4: 'Centre-Val de Loire' },
  '42': { aL6: 'Loire', aL4: 'Auvergne-Rhône-Alpes' },
  '43': { aL6: 'Haute-Loire', aL4: 'Auvergne-Rhône-Alpes' },
  '44': { aL6: 'Loire-Atlantique', aL4: 'Pays de la Loire' },
  '45': { aL6: 'Loiret', aL4: 'Centre-Val de Loire' },
  '46': { aL6: 'Lot', aL4: 'Occitanie' },
  '47': { aL6: 'Lot-et-Garonne', aL4: 'Nouvelle-Aquitaine' },
  '48': { aL6: 'Lozère', aL4: 'Occitanie' },
  '49': { aL6: 'Maine-et-Loire', aL4: 'Pays de la Loire' },
  '50': { aL6: 'Manche', aL4: 'Normandie' },
  '51': { aL6: 'Marne', aL4: 'Grand Est' },
  '52': { aL6: 'Haute-Marne', aL4: 'Grand Est' },
  '53': { aL6: 'Mayenne', aL4: 'Pays de la Loire' },
  '54': { aL6: 'Meurthe-et-Moselle', aL4: 'Grand Est' },
  '55': { aL6: 'Meuse', aL4: 'Grand Est' },
  '56': { aL6: 'Morbihan', aL4: 'Bretagne' },
  '57': { aL6: 'Moselle', aL4: 'Grand Est' },
  '58': { aL6: 'Nièvre', aL4: 'Bourgogne-Franche-Comté' },
  '59': { aL6: 'Nord', aL4: 'Hauts-de-France' },
  '60': { aL6: 'Oise', aL4: 'Hauts-de-France' },
  '61': { aL6: 'Orne', aL4: 'Normandie' },
  '62': { aL6: 'Pas-de-Calais', aL4: 'Hauts-de-France' },
  '63': { aL6: 'Puy-de-Dôme', aL4: 'Auvergne-Rhône-Alpes' },
  '64': { aL6: 'Pyrénées-Atlantiques', aL4: 'Nouvelle-Aquitaine' },
  '65': { aL6: 'Hautes-Pyrénées', aL4: 'Occitanie' },
  '66': { aL6: 'Pyrénées-Orientales', aL4: 'Occitanie' },
  '67': { aL6: 'Bas-Rhin', aL4: 'Grand Est' },
  '68': { aL6: 'Haut-Rhin', aL4: 'Grand Est' },
  '69': { aL6: 'Rhône', aL4: 'Auvergne-Rhône-Alpes' },
  '70': { aL6: 'Haute-Saône', aL4: 'Bourgogne-Franche-Comté' },
  '71': { aL6: 'Saône-et-Loire', aL4: 'Bourgogne-Franche-Comté' },
  '72': { aL6: 'Sarthe', aL4: 'Pays de la Loire' },
  '73': { aL6: 'Savoie', aL4: 'Auvergne-Rhône-Alpes' },
  '74': { aL6: 'Haute-Savoie', aL4: 'Auvergne-Rhône-Alpes' },
  '75': { aL6: 'Paris', aL4: 'Île-de-France' },
  '76': { aL6: 'Seine-Maritime', aL4: 'Normandie' },
  '77': { aL6: 'Seine-et-Marne', aL4: 'Île-de-France' },
  '78': { aL6: 'Yvelines', aL4: 'Île-de-France' },
  '79': { aL6: 'Deux-Sèvres', aL4: 'Nouvelle-Aquitaine' },
  '80': { aL6: 'Somme', aL4: 'Hauts-de-France' },
  '81': { aL6: 'Tarn', aL4: 'Occitanie' },
  '82': { aL6: 'Tarn-et-Garonne', aL4: 'Occitanie' },
  '83': { aL6: 'Var', aL4: "Provence-Alpes-Côte d'Azur" },
  '84': { aL6: 'Vaucluse', aL4: "Provence-Alpes-Côte d'Azur" },
  '85': { aL6: 'Vendée', aL4: 'Pays de la Loire' },
  '86': { aL6: 'Vienne', aL4: 'Nouvelle-Aquitaine' },
  '87': { aL6: 'Haute-Vienne', aL4: 'Nouvelle-Aquitaine' },
  '88': { aL6: 'Vosges', aL4: 'Grand Est' },
  '89': { aL6: 'Yonne', aL4: 'Bourgogne-Franche-Comté' },
  '90': { aL6: 'Territoire de Belfort', aL4: 'Bourgogne-Franche-Comté' },
  '91': { aL6: 'Essonne', aL4: 'Île-de-France' },
  '92': { aL6: 'Hauts-de-Seine', aL4: 'Île-de-France' },
  '93': { aL6: 'Seine-Saint-Denis', aL4: 'Île-de-France' },
  '94': { aL6: 'Val-de-Marne', aL4: 'Île-de-France' },
  '95': { aL6: "Val-d'Oise", aL4: 'Île-de-France' },
  '971': { aL6: 'Guadeloupe', aL4: 'Guadeloupe' },
  '972': { aL6: 'Martinique', aL4: 'Martinique' },
  '973': { aL6: 'Guyane', aL4: 'Guyane' },
  '974': { aL6: 'La Réunion', aL4: 'La Réunion' },
  '976': { aL6: 'Mayotte', aL4: 'Mayotte' },
  '975': { aL6: '', aL4: 'Saint-Pierre-et-Miquelon' },
  '977': { aL6: '', aL4: 'Saint-Barthélemy' },
  '978': { aL6: '', aL4: 'Saint-Martin' },
  '986': { aL6: '', aL4: 'Wallis-et-Futuna' },
  '987': { aL6: '', aL4: 'Polynésie française' },
  '988': { aL6: '', aL4: 'Nouvelle-Calédonie' },
};

const FRA_OPTIONS: Array<Option> = [
  { value: '01', label: 'Ain' },
  { value: '02', label: 'Aisne' },
  { value: '03', label: 'Allier' },
  { value: '04', label: 'Alpes-de-Haute-Provence' },
  { value: '05', label: 'Hautes-Alpes' },
  { value: '06', label: 'Alpes-Maritimes' },
  { value: '07', label: 'Ardèche' },
  { value: '08', label: 'Ardennes' },
  { value: '09', label: 'Ariège' },
  { value: '10', label: 'Aube' },
  { value: '11', label: 'Aude' },
  { value: '12', label: 'Aveyron' },
  { value: '13', label: 'Bouches-du-Rhône' },
  { value: '14', label: 'Calvados' },
  { value: '15', label: 'Cantal' },
  { value: '16', label: 'Charente' },
  { value: '17', label: 'Charente-Maritime' },
  { value: '18', label: 'Cher' },
  { value: '19', label: 'Corrèze' },
  { value: '2A', label: 'Corse-du-Sud' },
  { value: '2B', label: 'Haute-Corse' },
  { value: '21', label: "Côte-d'Or" },
  { value: '22', label: "Côtes-d'Armor" },
  { value: '23', label: 'Creuse' },
  { value: '24', label: 'Dordogne' },
  { value: '25', label: 'Doubs' },
  { value: '26', label: 'Drôme' },
  { value: '27', label: 'Eure' },
  { value: '28', label: 'Eure-et-Loir' },
  { value: '29', label: 'Finistère' },
  { value: '30', label: 'Gard' },
  { value: '31', label: 'Haute-Garonne' },
  { value: '32', label: 'Gers' },
  { value: '33', label: 'Gironde' },
  { value: '34', label: 'Hérault' },
  { value: '35', label: 'Ille-et-Vilaine' },
  { value: '36', label: 'Indre' },
  { value: '37', label: 'Indre-et-Loire' },
  { value: '38', label: 'Isère' },
  { value: '39', label: 'Jura' },
  { value: '40', label: 'Landes' },
  { value: '41', label: 'Loir-et-Cher' },
  { value: '42', label: 'Loire' },
  { value: '43', label: 'Haute-Loire' },
  { value: '44', label: 'Loire-Atlantique' },
  { value: '45', label: 'Loiret' },
  { value: '46', label: 'Lot' },
  { value: '47', label: 'Lot-et-Garonne' },
  { value: '48', label: 'Lozère' },
  { value: '49', label: 'Maine-et-Loire' },
  { value: '50', label: 'Manche' },
  { value: '51', label: 'Marne' },
  { value: '52', label: 'Haute-Marne' },
  { value: '53', label: 'Mayenne' },
  { value: '54', label: 'Meurthe-et-Moselle' },
  { value: '55', label: 'Meuse' },
  { value: '56', label: 'Morbihan' },
  { value: '57', label: 'Moselle' },
  { value: '58', label: 'Nièvre' },
  { value: '59', label: 'Nord' },
  { value: '60', label: 'Oise' },
  { value: '61', label: 'Orne' },
  { value: '62', label: 'Pas-de-Calais' },
  { value: '63', label: 'Puy-de-Dôme' },
  { value: '64', label: 'Pyrénées-Atlantiques' },
  { value: '65', label: 'Hautes-Pyrénées' },
  { value: '66', label: 'Pyrénées-Orientales' },
  { value: '67', label: 'Bas-Rhin' },
  { value: '68', label: 'Haut-Rhin' },
  { value: '69', label: 'Rhône' },
  { value: '70', label: 'Haute-Saône' },
  { value: '71', label: 'Saône-et-Loire' },
  { value: '72', label: 'Sarthe' },
  { value: '73', label: 'Savoie' },
  { value: '74', label: 'Haute-Savoie' },
  { value: '75', label: 'Paris' },
  { value: '76', label: 'Seine-Maritime' },
  { value: '77', label: 'Seine-et-Marne' },
  { value: '78', label: 'Yvelines' },
  { value: '79', label: 'Deux-Sèvres' },
  { value: '80', label: 'Somme' },
  { value: '81', label: 'Tarn' },
  { value: '82', label: 'Tarn-et-Garonne' },
  { value: '83', label: 'Var' },
  { value: '84', label: 'Vaucluse' },
  { value: '85', label: 'Vendée' },
  { value: '86', label: 'Vienne' },
  { value: '87', label: 'Haute-Vienne' },
  { value: '88', label: 'Vosges' },
  { value: '89', label: 'Yonne' },
  { value: '90', label: 'Territoire de Belfort' },
  { value: '91', label: 'Essonne' },
  { value: '92', label: 'Hauts-de-Seine' },
  { value: '93', label: 'Seine-Saint-Denis' },
  { value: '94', label: 'Val-de-Marne' },
  { value: '95', label: "Val-d'Oise" },
  { value: '971', label: 'Guadeloupe' },
  { value: '972', label: 'Martinique' },
  { value: '973', label: 'Guyane' },
  { value: '974', label: 'La Réunion' },
  { value: '976', label: 'Mayotte' },
  { value: '975', label: 'Saint-Pierre-et-Miquelon' },
  { value: '977', label: 'Saint-Barthélemy' },
  { value: '978', label: 'Saint-Martin' },
  { value: '984', label: 'Wallis-et-Futuna' },
  { value: '986', label: 'Polynésie française' },
  { value: '987', label: 'Polynésie française' },
  { value: '988', label: 'Nouvelle-Calédonie' },
];

function getFrenchOSM(input: string): { aL6: string; aL4: string } | null {
  if (input.slice(0, 2) === '20') {
    return getCorsicaDepartment(parseInt(input));
  }
  input = sliceFrenchZipCode(input);

  if (input.length === 1) input = '0' + input;

  let found = FRA_ZIP_TABLE[input];
  if (found) found = JSON.parse(JSON.stringify(found));
  return found;
}

function sliceFrenchZipCode(zipCode: string): string {
  const zip = zipCode.slice(0, 3);
  return zip.startsWith('971') ? zip.toString().slice(0, 3) : zip.toString().slice(0, 2);
}

function getCorsicaDepartment(zipCode: number) {
  const A = [
    [20000, 20199],
    [20200, 20207],
    [20212, 20213],
    [20217, 20219],
  ];
  if (
    A.some((it) => {
      return zipCode >= it[0] && zipCode <= it[1];
    })
  )
    return { aL6: 'Corse-du-Sud', aL4: 'Corse' };

  const B = [
    [20208, 20211],
    [20214, 20216],
    [20220, 20299],
    [20600, 20699],
  ];
  if (
    B.some((it) => {
      return zipCode >= it[0] && zipCode <= it[1];
    })
  )
    return { aL6: 'Haute-Corse', aL4: 'Corse' };
  return null;
}

export { FRA_OPTIONS, getFrenchOSM, sliceFrenchZipCode };
